import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import './SlideWrap.less';

interface SlideWrapPropsType extends React.HTMLAttributes<HTMLDivElement> {
  getContainer?: string, 
}

const SlideWrap: React.FC<SlideWrapPropsType> = ({ className, children, getContainer = 'body', ...restProps }) => {
  const dialogNode = React.useRef<HTMLElement>(document.createElement('section'));
  const originalOverflowCallback = React.useRef('');

  React.useEffect(() => {
    (document.querySelector(getContainer) || document.body).appendChild(dialogNode.current);
    const { style } = document.body;
    originalOverflowCallback.current = style.overflow;
    style.overflow = 'hidden';

    return () => {
      style.overflow = originalOverflowCallback.current;
      // 清除容器
      (document.querySelector(getContainer) || document.body).removeChild(dialogNode.current);
    };
  }, []);

  return createPortal(
    <div className={classNames('PhotoView-SlideWrap', className)} {...restProps}>
      {children}
    </div>,
    dialogNode.current,
  );
};

SlideWrap.displayName = 'SlideWrap';

export default SlideWrap;
